const GalleryConstants = {
  SLIDING_TYPE_FILMSTRIP: "filmstrip",
  SLIDING_TYPE_SINGLE_FIT: "single-fit",
  SLIDING_TYPE_SINGLE_FILL: "single-fill",

  SLIDING_DOT_LOC_IN: "in",
  SLIDING_DOT_LOC_OUT: "out",

  //DEFAULTS
  SLIDING_DOT_ACTIVE_COLOR: "colors-1",
  SLIDING_DOT_BASE_COLOR: "colors-1:25",
  SLIDING_DOT_GAP: 10, //space between dots
  SLIDING_DOT_LOC: "out",
  SLIDING_DOT_OFFSET: 10, //the amount of space between dots and image area
  SLIDING_DOT_SIZE: 10, //default size of dots

  SLIDING_PRELOAD: 3,
};

export default GalleryConstants;
